// extracted by mini-css-extract-plugin
export default {"container":"AssignmentItem_container__Z+J8p","title":"AssignmentItem_title__Hwg+H"};